import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useSeo } from "../lib/useSeo";

export default function AuthCallback() {
  const { exchangeEmergentSession } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);
  // iter222 — noindex this transient OAuth bounce page.
  useSeo({ title: "Signing you in… — CampCompass UK", noindex: true });

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const sid = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { isNew } = await exchangeEmergentSession(sid);
        // clear hash
        window.history.replaceState({}, document.title, window.location.pathname);
        toast.success(isNew ? "Welcome to CampCompass!" : "Signed in with Google");
        // iter198 — brand-new Google signups go through the celebratory
        // ?welcome=1 flow so they get the confetti + "here's what
        // unlocked" screen. Returning members skip straight to /browse.
        nav(isNew ? "/?welcome=1" : "/browse");
      } catch (e) {
        toast.error("Sign-in failed");
        nav("/login");
      }
    })();
  }, [exchangeEmergentSession, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-[#555]" data-testid="auth-callback">
      <Loader2 className="w-5 h-5 animate-spin mr-2" /> Signing you in…
    </div>
  );
}
